import { api, type Config, getRequestBody } from './api';

export async function post<T>(url: string, data: any, config?: Config): Promise<T> {
  const body = getRequestBody(data);
  return api<T>(`${url}${config?.params ? `?${new URLSearchParams(config.params).toString()}` : ''}`, {
    ...(body && { body }),
    method: 'post',
    ...(config?.headers && { headers: config.headers }),
    ...(config?.credentials && { credentials: config.credentials })
  });
}
